<template>
    <div
        class="apprentice-simple-card"
        :style="{ backgroundColor: slideIn.color }">
        <div
            class="single-inputs"
            v-if="!double">
            <div
                class="single-input"
                v-for="(item, key) in singleListItems">
                <div class="name-input-wrapper">
                    <b-form-input
                        v-model="item.name"
                        :placeholder="$t('common.name')">
                    </b-form-input>

                    <b-form-textarea
                        v-model="item.value"
                        :placeholder="$t('presentation.fill_in_text_here')"
                        rows="1">
                    </b-form-textarea>
                </div>

                <b-button
                    class="btn-remove-single-name-input"
                    variant="danger-icon-only"
                    @click="removeItem(item)">
                    <i class="fa fa-trash-alt"></i>
                </b-button>
            </div>
        </div>

        <div
            class="dual-inputs"
            v-else>
            <div
                class="dual-input"
                v-for="(item, key) in doubleListItems">
                <div class="inputs">
                    <b-form-input
                        v-model="item.name"
                        :placeholder="$t('common.name')">
                    </b-form-input>

                    <b-form-textarea
                        v-model="item.value"
                        :placeholder="$t('presentation.fill_in_text_here')"
                        rows="1">
                    </b-form-textarea>

                    <b-form-textarea
                        v-model="item.value_second"
                        :placeholder="$t('presentation.fill_in_text_here')"
                        rows="1">
                    </b-form-textarea>
                </div>

                <b-button
                    class="btn-remove-dual-input"
                    variant="danger-icon-only"
                    @click="removeItem(item)">
                    <i class="fa fa-trash-alt"></i>
                </b-button>
            </div>
        </div>

        <div class="actions">
            <b-button
                class="btn-toggle"
                v-b-tooltip:hover
                variant="primary"
                :title="double ? 'switch naar 1 kolom' : 'switch naar 2 kolom'"
                @click="toggleDouble">
                <i
                    class="icon fa"
                    :class="double ? 'fa-th-list' : 'fa-th-large'">
                </i>
            </b-button>

            <b-button
                class="btn-add"
                variant="primary"
                @click="addItem">
                {{ $t('common.add') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-edit-list-named-type-component',
    props: {
        slideIn: Object,
    },
    data() {
        return {
            double: false,
        };
    },
    computed: {
        singleListItems() {
            return this.slideIn.list_items.filter((item) => !item.uses_double_columns);
        },
        doubleListItems() {
            return this.slideIn.list_items.filter((item) => item.uses_double_columns === 1);
        },
    },
    methods: {
        addItem() {
            let data = {
                uses_double_columns: this.double,
            };

            this.axios.post(this.routes.presentationSlideListItemStore(this.slideIn.id), data).then(
                (response) => {
                    this.$emit('presentation-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        removeItem(item) {
            this.axios.delete(this.routes.presentationRemoveListItem(item.id)).then(
                (response) => {
                    this.$emit('presentation-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        toggleDouble() {
            this.double = !this.double;
        },
    },
};
</script>

<style scoped lang="scss">
.single-input,
.dual-input {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: $grid-gutter-width;
    justify-content: flex-start;
    margin-bottom: $grid-gutter-width;

    .button {
        font-size: 1.3125rem;
    }
}

.name-input-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;
    justify-content: flex-start;
    flex: 1 0;

    input {
        flex: 1 0 calc(100% - 15px);
        margin: 0;
        align-self: flex-start;
    }

    textarea {
        flex: 1 0 calc(100% - 15px);
    }
}

.dual-input {
    .inputs {
        flex: 1 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;

        input {
            flex: 1 0 calc(100% - 15px);
            margin: 0;
            align-self: flex-start;
        }

        textarea {
            flex: 1 0 calc(100% - 15px);
        }
    }
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;

    .btn-toggle {
        line-height: 1;
        padding: map-get($grid-gutter-spacing, 'ten');
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .name-input-wrapper {
        input {
            flex: 1 0 calc(10% - 15px);
            max-width: 300px;
        }

        textarea {
            flex: 1 0 calc(65% - 15px);
        }
    }

    .dual-input {
        .inputs {
            input {
                flex: 1 0 calc(15% - 15px);
            }

            textarea {
                flex: 1 0 calc(30% - 15px);
            }
        }
    }
}
</style>
